import styled from "styled-components";
// export const ErrorMessage = styled.span`
//     color: crimson;
//     font-size: 14px;
//     `
export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 5px;
  display: block;
`;
